import React from 'react';

import MenuContext from '../MenuContext';

import * as T from './MenuProvider.types';

export const MenuProvider: React.FunctionComponent<T.IMenuProviderProps> = ({
  showMenu,
  children,
}) => {
  const [show, setShow] = React.useState<boolean>(showMenu);

  React.useEffect(() => {
    setShow(showMenu);
  }, [showMenu]);

  const toggle = (): void => {
    setShow(!show);
  };

  return (
    <MenuContext.Provider value={{ show, toggle }}>
      {children}
    </MenuContext.Provider>
  );
};
